module.exports = __webpack_public_path__ + "img/common-file-double-1.c5c3883e.svg";